module.exports = __webpack_public_path__ + "static/media/dq-spinner.120f3d39.120f3d39.png";